export default __webpack_public_path__ + "static/media/bci-1.eba08529.svg";